export const SESSION_TYPE = Object.freeze({
  FIXED: 'FIXED',
  FLEXIBLE: 'FLEXIBLE',
  OWNER_PHOTOS: 'OWNER_PHOTOS',
});

export const RESCHEDULE_ERROR = Object.freeze({
  GENERIC: 'GENERIC',
  LAST_PHOTOGRAPHER_UNAVAILABLE: 'LAST_PHOTOGRAPHER_UNAVAILABLE',
});
